<template>
  <div :class="rootClass">
    <b-card
        :class="rootClass + '__card'"
        class="bg-transparent border border-danger p-2 rounded-5"
    >
      <b-row class="mb-4">
        <b-col :class="rootClass + '__title'" lg="8" md="6" sm="12">
          Chào mừng bạn đến với hệ thống Quản lý thông tin Khách hàng
        </b-col
        >
      </b-row>
      <b-row class="mb-2">
        <b-col lg="8" md="6" sm="12" style="font-weight: 500">
          Vui lòng nhập 1 trong 3 nội dung sau để tra cứu thông tin Khách hàng
        </b-col
        >
      </b-row
      >
      <b-row class="mb-2">
        <b-col class="mb-1" style="max-width: 7%;">
          <br/>
          <b-form-input :disabled="true" :value="'+84'"></b-form-input>
        </b-col>
        <b-col class=" mb-1 mr-4" lg="3" md="9" sm="9"
               style="padding-left:5px !important;padding-right:5px !important; ">
          <span class="searchInput__header">Số thuê bao iTel</span>
          <b-form-input
              ref="inputPhoneSearch"
              v-model="inputPhoneNum"
              :disabled="noNumberInput.length!=0||msinInput.length!=0"
              type="number"
              v-on:keyup.enter="checkKeyPress">
          </b-form-input>
          <b-row v-if="showErrMessPhone" style="color: red; margin: 2% 0% 0% 5%">
            Vui lòng nhập số itel
          </b-row>
        </b-col>
        <b-col class=" mb-1 mr-4" lg="3" md="9" sm="9"
               style="padding-left:5px !important;padding-right:5px !important; ">
          <span class="searchInput__header">Số CCCD/CMND</span>
          <b-form-input
              ref="inputPhoneSearch"
              v-model="noNumberInput"
              :disabled="inputPhoneNum.length!=0||msinInput.length!=0"
              type="number"
              v-on:keyup.enter="checkKeyPress">
          </b-form-input>
        </b-col>
        <b-col class=" mb-1" lg="3" md="9" sm="9" style="padding-left:5px !important;padding-right:5px !important; ">
          <span class="searchInput__header">Số Serial Sim</span>
          <b-form-input
              ref="inputPhoneSearch"
              v-model="msinInput"
              :disabled="noNumberInput.length!=0||inputPhoneNum.length!=0"
              type="number"
              v-on:keyup.enter="checkKeyPress">
          </b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="mb-1 ml-1" lg="8" md="12" sm="12">
          <b-row style="padding-left: 0px !important;">
            <b-button
                :class="rootClass + '__lookup-popup-btn'"
                class=" mb-1 redBtn"
                variant="danger"
                @click="onPopupSearch"
            >Tra cứu
              <span :class="rootClass + '__lookup-popup-btn-text'"
              >(popup)</span
              ></b-button
            >
            <b-button
                :class="rootClass + '__lookup-newtab-btn'"
                class=" mb-1 redBtn"
                style="margin-left: 0.5rem"
                variant="danger"
                @click="onNewTabSearch"
            >Tra cứu
              <span :class="rootClass + '__lookup-newtab-btn-text'"
              >(cửa sổ mới)</span
              ></b-button
            >
          </b-row>
        </b-col>
      </b-row>

      <b-row
      >
        <b-col :class="rootClass + '__note'" cols="12">Ghi chú</b-col>
      </b-row
      >
      <b-row>
        <b-col lg="6" md="6" sm="12" style="font-weight: 500"
        >Tra cứu (popup): Sẽ hiển thị một cửa sổ popup (Phím tắt:
          Enter)
        </b-col
        >
      </b-row
      >
      <b-row>
        <b-col lg="6" md="6" sm="12" style="font-weight: 500"
        >Tra cứu (cửa sổ mới): Sẽ hiển thị một cửa sổ mới (Phím tắt:
          Shift+Enter)
        </b-col
        >
      </b-row
      >
    </b-card>
    <ListSubcriberContent v-if="showListSubscriberContent" style="position: absolute; top:100px;right:25px; left: 25px"
                          @closeContentTab="(msg)=>showListSubscriberContent=msg"></ListSubcriberContent>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ListSubcriberContent from "@/views/subscriber/ListSubcriberContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ListSubcriberContent,
  },
  data() {
    return {
      showErrMessPhone: false,
      rootClass: "subcriber-lookup",
      phoneNumberSearch: "",
      regex087: /87\d{7}$/,
      inputPhoneNum: "",
      showListSubscriberContent: false,
      msinInput: "",
      noNumberInput: "",
    };
  },
  mounted() {
    console.log(this.$router.currentRoute.name)

  },
  methods: {
    checkKeyPress(e) {
      if (e.shiftKey) {
        return this.onNewTabSearch()
      } else {
        return this.onPopupSearch()
      }
    },
    formatPhoneNum() {
      if (this.inputPhoneNum.startsWith("0")) {
        this.phoneNumberSearch = this.inputPhoneNum.substring(1);
      } else if (this.inputPhoneNum.startsWith("84")) {
        this.phoneNumberSearch = this.inputPhoneNum.substring(2);
      } else {
        this.phoneNumberSearch = this.inputPhoneNum;
      }
      console.log(this.phoneNumberSearch);
    },
    onNewTabSearch: function (e) {
      localStorage.setItem('phoneNumberSearch', "");
      this.formatPhoneNum()
      if (this.phoneNumberSearch.length > 0) {
        if (this.regex087.test(this.phoneNumberSearch)) {
          this.setOpenTabContent("SubscriberInformation")
          this.savePhoneNumberSearch();
          const routeData = this.$router.resolve({
            name: "subcriber-content",
          });
          setTimeout(() => {
            window.open(routeData.href, '_blank')
          }, 10)
        } else {
          this.showErrMessPhone = true;
          this.$refs.inputPhoneSearch.focus();
        }
      }
      if (this.noNumberInput.length > 0) {
        this.setOpenTabContent("NoNumberToMsindn")
        localStorage.setItem('noNumberInput', this.noNumberInput);
        const routeData = this.$router.resolve({
          name: "subcriber-content",
        });
        setTimeout(() => {
          window.open(routeData.href, '_blank')
        }, 10)
      }
      if (this.msinInput.length > 0) {
        this.setOpenTabContent("MsinToMsisdn")
        localStorage.setItem('msinInput', this.msinInput);
        const routeData = this.$router.resolve({
          name: "subcriber-content",
        });
        setTimeout(() => {
          window.open(routeData.href, '_blank')
        }, 10)
      }
    },
    onPopupSearch: function (e) {
      localStorage.setItem('phoneNumberSearch', "");
      this.formatPhoneNum()
      if (this.phoneNumberSearch.length > 0) {
        if (this.regex087.test(this.phoneNumberSearch)) {
          this.savePhoneNumberSearch();
          this.setOpenTabContent("SubscriberInformation")
          this.showListSubscriberContent = true
          // this.$router.push({name: "subcriber-content"});
        } else {
          this.showErrMessPhone = true;
          this.$refs.inputPhoneSearch.focus();
        }
      }
      if (this.noNumberInput.length > 0) {
        this.showListSubscriberContent = true
        localStorage.setItem('noNumberInput', this.noNumberInput);
        this.setOpenTabContent("NoNumberToMsindn")

      }
      if (this.msinInput.length > 0) {
        this.showListSubscriberContent = true
        localStorage.setItem('msinInput', this.msinInput);
        this.setOpenTabContent("MsinToMsisdn")

      }
    },
    savePhoneNumberSearch() {
      localStorage.setItem('phoneNumberSearch', this.phoneNumberSearch);
    },
    setOpenTabContent(tab) {
      localStorage.setItem('tabOpen', tab);
    }
  },
};
</script>

<style lang="scss" scoped>
.subcriber-lookup {
  font-family: "Montserrat";
  font-weight: 300;
  color: #5e5873;

  &__title {
    font-size: 24px;
    font-weight: 600;
    color: #505050;
  }

  &__label {
    font-weight: 400;
  }

  &__card {
    border-radius: 2rem;
  }

  &__lookup-popup-btn {
    border-radius: 2rem;
    font-weight: bold;

    &-text {
      font-weight: 100;
    }
  }

  &__lookup-newtab-btn {
    border-radius: 2rem;
    font-weight: bold;

    &-text {
      font-weight: 100;
    }
  }

  &__note {
    font-size: 16px;
    font-weight: 700;
  }

  .redBtn {
    background-color: #ED1F24 !important;
    border-color: #ED1F24 !important;
  }

  .searchInput__header {
    font-weight: 500;
  }
}
</style>
